module.exports = __webpack_public_path__ + "static/media/dataset-1.b1f8d2c4.PNG";